<div class="search-container-details">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">manage_search</cll-icon>
        <div class="accordion-sub-title-accordion">
            <span class="detail-table-title">Audit</span>
            <span class="detail-table-sub-title">A record of all changes made</span>
        </div>
    </div>
</div>

<div class="tabs-table-container">
    @if (isLoading()) {
        <cll-spinner />
    } @else if (error()) {
        <p class="no-data-row">{{ error() }}</p>
    } @else {
        <table class="cll-table">
            <thead>
            <tr>
                <th>Timestamp</th>
                <th>Event</th>
                <th>Description</th>
                <th>Subject</th>
                <th>Causer</th>
                <th>IP Address</th>
                <th>Device</th>
            </tr>
            </thead>
            <tbody>
            @for (entry of activities(); track entry.id) {
                <tr class="clickable" (click)="openEntry(entry)">
                    <td class="audit-timestamp">{{ entry.created_at | appDate: 'longDateTime' }}</td>
                    <td>
                        <cll-badge [colour]="eventBadgeColour(entry.event)">{{ eventLabel(entry.event) }}</cll-badge>
                    </td>
                    <td>{{ entry.description }}</td>
                    <td>
                        @if (changedFields(entry)[0]; as field) {
                            <div class="audit-cell-stack">
                                <span class="audit-cell-primary">{{ field.label }}</span>
                                <span class="audit-cell-sub">{{ field.newValue }}</span>
                            </div>
                            @if (extraFieldCount(entry) > 0) {
                                <span class="audit-cell-sub">+{{ extraFieldCount(entry) }} more</span>
                            }
                        } @else {
                            <span class="audit-cell-primary">—</span>
                        }
                    </td>
                    <td>
                        @if (entry.causer) {
                            <div class="audit-cell-stack">
                                <span class="audit-cell-primary">{{ entry.causer.name ?? entry.causer.email }}</span>
                                @if (entry.causer.name) {
                                    <span class="audit-cell-sub">{{ entry.causer.email }}</span>
                                }
                            </div>
                        } @else {
                            <span class="audit-cell-primary">—</span>
                        }
                    </td>
                    <td>{{ entry.ip_address ?? '—' }}</td>
                    <td>{{ entry.user_agent ?? '—' }}</td>
                </tr>
            } @empty {
                <tr>
                    <td colspan="7" class="no-data-row">
                        <div class="no-data-wrapper-tabs">No audit entries found.</div>
                    </td>
                </tr>
            }
            </tbody>
        </table>

        @if ((meta()?.last_page ?? 1) > 1) {
            <div class="pagination-controls">
                <button cll-button [disabled]="!hasPrev()" (click)="goToPage(currentPage() - 1)">Previous</button>
                <span>Page {{ currentPage() }} of {{ lastPage() }}</span>
                <button cll-button [disabled]="!hasNext()" (click)="goToPage(currentPage() + 1)">Next</button>
            </div>
        }
    }
</div>
